// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"610689e3","732":"a3d70d38","977":"6937894a"}[chunkId] + ".chunk.js";
};